'use client';

import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';

import { cn } from '@/lib/utils';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} className={className} {...props} />
));
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & {
    useToggleIcon?: boolean;
  }
>(({ className, children, useToggleIcon = false, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        'group flex flex-1 justify-between gap-[2rem] sm:gap-[2.5rem] items-center outline-none',
        className,
      )}
      {...props}
    >
      {children}

      {useToggleIcon ? (
        <div className=" rounded-[1rem] relative flex items-center justify-center w-[3.5rem] h-[3.5rem] flex-shrink-0">
          <div className="w-[1.75rem] h-[0.125rem] flex-shrink-0  rounded-[5px] bg-black" />
          <div className="absolute h-[1.75rem] w-[0.125rem] group-data-[state=open]:h-0 transition-all duration-300 ease-in-out  flex-shrink-0 rounded-[5px] bg-black" />
        </div>
      ) : (
        <div className="font-nunito text-[1.75rem] lg:text-[3rem] w-[20rem] text-offwhite uppercase font-[300] relative lg:-translate-x-[8rem]">
          <span className="group-data-[state=open]:opacity-0 transition-opacity duration-300">
            More info
          </span>
          <span className="group-data-[state=open]:opacity-100 absolute top-0 left-1/2 -translate-x-1/2 opacity-0 transition-opacity duration-300">
            CLOSE
          </span>
        </div>
      )}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn('pb-4 pt-0', className)}>{children}</div>
  </AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
